import { Component } from "@angular/core"

@Component({
  selector: "app-main-content",
  imports: [],
  template: `<main id="mainContent" role="main">
    <ng-content></ng-content>
  </main>`,
  styles: [`
    :host {
      display: flex;
      flex: 1;
      flex-direction: column;
    }
    main {
      display: flex;
      flex: 1;
      flex-direction: column;
    }
  `],
})
export class MainContentComponent {}
